import * as React from "react"
import { Slot } from "@radix-ui/react-slot"
import { cva } from "class-variance-authority";

import { cn } from "@/lib/utils"

const buttonVariants = cva(
  "inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-[var(--radius-md)] font-[family-name:var(--font-sans-ui)] text-sm font-medium [transition:all_var(--motion-quick)] focus-visible:outline-none disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0",
  {
    variants: {
      variant: {
        default:
          "bg-[var(--accent-gold)] text-[var(--ink-inverse)] hover:bg-[var(--accent-gold-hover)] hover:-translate-y-[1px] hover:shadow-[var(--shadow-card)]",
        destructive:
          "bg-[var(--semantic-error)] text-[var(--ink-inverse)] hover:opacity-90",
        outline:
          "border border-[var(--border-strong)] text-[var(--ink-primary)] hover:border-[var(--accent-gold)]",
        secondary:
          "bg-[var(--surface-sunk)] text-[var(--ink-primary)] border border-[var(--border-subtle)] hover:bg-[var(--surface-hover)]",
        ghost: "text-[var(--ink-secondary)] hover:bg-[var(--surface-hover)] hover:text-[var(--ink-primary)]",
        link: "text-[var(--accent-gold)] underline-offset-4 hover:underline",
      },
      size: {
        default: "px-[18px] py-[10px]",
        sm: "h-8 rounded-[var(--radius-md)] px-3 text-xs",
        lg: "h-10 rounded-[var(--radius-md)] px-8",
        icon: "h-9 w-9",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "default",
    },
  }
)

const Button = React.forwardRef(({ className, variant, size, asChild = false, ...props }, ref) => {
  const Comp = asChild ? Slot : "button"
  return (
    <Comp
      className={cn(buttonVariants({ variant, size, className }))}
      ref={ref}
      {...props} />
  );
})
Button.displayName = "Button"

export { Button, buttonVariants }